
import { Link } from "react-router-dom";
import { NAME, PHONE } from "../constants";
import scope from "../assets/scope.jpg";

export default function WhoWeAre() {
    return (
        <div>
            <div className="container grid lg:grid-cols-2 items-center gap-10 pb-20">
                <div>
                    <p className="uppercase text-sm main-color font-medium">Who We Are</p>
                    <div className="flex flex-col gap-6">
                        <h2 className="text-4xl font-semibold mt-3 leading-tight">
                            TouchLife Medical Care Foundation
                        </h2>
                        <h3 className="text-2xl font-medium">
                            We strive to make medical care affordable
                        </h3>
                        <p>
                            Touchlife Medical Care Foundation is a nonprofit health center
                            located in Ober, Oyam district Northern Uganda. It brings improved
                            medical services closer to the people and seeks to reach out and
                            meet the wholistic health need of the community in which it
                            serves.
                        </p>
                        <div className="flex">
                            <Link to={"/about"} className="main-btn px-8 py-3 mt-3">
                                Learn more
                            </Link>
                        </div>
                    </div>
                </div>
                <div>
                    <img
                        src={scope}
                        alt={NAME}
                        fill={false}
                        className="w-full aspect-[3/2] object-contain"
                    />
                </div>
            </div>
            <div className="call-bg overlay py-20">
                <div className="max-w-sm lg:max-w-xl mx-auto text-2xl lg:text-3xl text-center relative">
                    <h5 className="text-white font-medium leading-normal">
                        Do you need Emergency Medical Care? Call @ {PHONE}
                    </h5>
                    <div className="mt-10">
                        <Link
                            href={"/contact"}
                            className="bg-white rounded main-color text-sm lg:text-base px-8 py-4 font-medium"
                        >
                            Contact us
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
